import './chat/bn_chat'
import './account/planConstructor'
import './account/payoutRequests'
import './author/bn_author'
import './account/bn_cycles'
import './account/bn_recommends'
import './account/bn_novels'
import './account/bn_pe-form'
import './feedback/bn_feedback'
import './contest/contest'
import './book/bn_book'
import './collections/bn_collections'